/**
 * Copyright © Veeam Software Group GmbH.
 */

import { ManagerTypeRepresentation } from '@veeam-vspc/models/web-controllers';

export type ManagerType = ManagerTypeRepresentation;
export const ManagerType = ManagerTypeRepresentation;
